import { useQuery } from '@tanstack/react-query';
import { fetchApplicationCounters } from '@company/services/application/api';
import QueryKeys from '@constants/queryKeys';

export function useCandidateCounters(jobId: number) {
  return useQuery({
    queryKey: [QueryKeys.JobDetail.CANDIDATE_COUNTERS, jobId],
    queryFn: () => fetchApplicationCounters(jobId),
    enabled: !!jobId,
  });
}
